export default __webpack_public_path__ + "static/media/edit_icon.57817fd3.svg";